module.exports = __webpack_public_path__ + "media/images/flags/4x3/slv-c5b7a88da0a76e8d558478f7dfd5a666.svg";